import script from "./OtherCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherCourses.vue?vue&type=script&setup=true&lang=js"

import "./OtherCourses.vue?vue&type=style&index=0&id=eb31b3a8&scoped=true&lang=css"

import exportComponent from "/var/www/almustafa-laravel-live/releases/20261104161609/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb31b3a8"]])

export default __exports__